<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button class="qinang-button-margin" icon="plus" @click="addVisible = true">新增</a-button>
				<a-button class="qinang-button-margin" icon="edit" @click="tableEdit">修改</a-button>
				<a-button class="qinang-button-margin" icon="delete" @click="tableDel">删除</a-button>
				<a-button icon="sync" @click="apiTicketstationQueryList">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="售票点查询">
				<div style="display: flex;justify-content: space-between;">
					<div style="width: 30%;display: flex;align-items: center;">
						<div style="width: 120px;">所属服务商：</div>
						<a-select v-model="query.facilitatorId" style="width: 100%;">
							<a-select-option v-for="(item,index) in facilitatorList" :value="item.facilitatorId" :key="index">{{item.facilitatorName}}</a-select-option>
						</a-select>
					</div>
					<div style="width: 30%;display: flex;align-items: center;">
						<div style="width: 120px;">售票点名称：</div>
						<a-input v-model="query.ticketstationName" style="width: 100%;" placeholder="请输入名称关键字查询" />
					</div>
					<div style="width: 30%;display: flex;align-items: center;justify-content: flex-end;">
						<a-button type="primary" icon="search" @click="apiTicketstationQueryList">查询</a-button>
					</div>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="ticketstationId" :loading="tableLoading" :pagination="false">
				<span slot="ticketstationName" slot-scope="ticketstationName">
					<a-button type="link" @click="edit(ticketstationName)" >{{ticketstationName.ticketstationName}}</a-button>
				</span>
				<span slot="facilitatorId" slot-scope="facilitatorId">
					{{mainNavigation[0].facilitatorName}}
				</span>
				<span slot="ticketstationState" slot-scope="ticketstationState">
					<span v-if="ticketstationState == 2">禁用</span>
					<span v-if="ticketstationState == 3">启用</span>
				</span>
			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>

		<!-- 添加弹窗 -->		
		<a-modal title="添加" width="60%" :visible="addVisible" :confirm-loading="addConfirmLoading" @ok="addHandleOk" @cancel="addVisible = false" :maskClosable="false" :keyboard="false" >
			<a-form-model style="" ref="addRuleForm" :model="addForm" :label-col="{span: 4}" :wrapper-col="{span: 18}" :rules="addRules">
				<a-form-model-item label="服务商名称" has-feedback prop="facilitatorId">
					<a-select v-model="addForm.facilitatorId" >
						<a-select-option v-for="(item,index) in facilitatorList" :value="item.facilitatorId" :key="index">{{item.facilitatorName}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="售票点名称" has-feedback prop="ticketstationName">
					<a-input v-model="addForm.ticketstationName" placeholder="请输入售票站点名称" />
				</a-form-model-item>
				<a-form-model-item label="联系人" has-feedback prop="contacts">
					<a-input v-model="addForm.contacts" placeholder="请输入联系人姓名" />
				</a-form-model-item>
				<a-form-model-item label="联系电话" has-feedback prop="tel">
					<a-input v-model="addForm.tel" placeholder="请输入联系电话" />
				</a-form-model-item>
				<a-form-model-item label="地址" has-feedback prop="address">
					<a-input v-model="addForm.address" placeholder="请输入售票站点地址" />
				</a-form-model-item>
				<a-form-model-item label="是否启用" has-feedback prop="ticketstationState">
					<a-radio-group name="ticketstationState" v-model="addForm.ticketstationState">
						<a-radio :value="3">是</a-radio>
						<a-radio :value="2">否</a-radio>
					</a-radio-group>
				</a-form-model-item>
				<a-form-model-item label="备注" has-feedback prop="remarks">
					<a-textarea placeholder="在这里输入备注" :rows="4" v-model="addForm.remarks" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		
		<!-- 修改弹窗 -->
		<a-modal title="修改" width="60%" :visible="editVisible" :confirm-loading="editConfirmLoading" @ok="editHandleOk" @cancel="editVisible = false"  :maskClosable="false" :keyboard="false">
			<a-form-model style="" ref="editRuleForm" :model="editForm" :label-col="{span: 4}" :wrapper-col="{span: 18}" :rules="addRules">
				<a-form-model-item label="服务商名称" has-feedback prop="facilitatorId">
					<a-select v-model="editForm.facilitatorId" disabled>
						<a-select-option v-for="(item,index) in facilitatorList" :value="item.facilitatorId" :key="index">{{item.facilitatorName}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="售票点名称" has-feedback prop="ticketstationName">
					<a-input v-model="editForm.ticketstationName" placeholder="请输入售票站点名称" />
				</a-form-model-item>
				<a-form-model-item label="联系人" has-feedback prop="contacts">
					<a-input v-model="editForm.contacts" placeholder="请输入联系人姓名" />
				</a-form-model-item>
				<a-form-model-item label="联系电话" has-feedback prop="tel">
					<a-input v-model="editForm.tel" placeholder="请输入联系电话" />
				</a-form-model-item>
				<a-form-model-item label="地址" has-feedback prop="address">
					<a-input v-model="editForm.address" placeholder="请输入售票站点地址" />
				</a-form-model-item>
				<a-form-model-item label="是否启用" has-feedback prop="ticketstationState">
					<a-radio-group name="ticketstationState" v-model="editForm.ticketstationState">
						<a-radio :value="3">是</a-radio>
						<a-radio :value="2">否</a-radio>
					</a-radio-group>
				</a-form-model-item>
				<a-form-model-item label="备注" has-feedback prop="remarks">
					<a-textarea placeholder="在这里输入备注" :rows="4" v-model="editForm.remarks" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		
	</div>
</template>

<script>
	import moment from 'moment'
	export default {
		data() {
			return {
				moment,
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				facilitatorList: [],
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					facilitatorId: '',
					ticketstationName: '',
				},
				mainNavigation:{},
				tableData: [],
				tableColumns: [
					{ title:'ID', dataIndex:'ticketstationId', key:'ticketstationId', align:'center'},
					{ title:'售票点名称', key:'ticketstationName', align:'center', scopedSlots:{customRender:'ticketstationName'}},
					{ title:'所属服务商', key:'facilitatorId', align:'center', scopedSlots:{customRender:'facilitatorId'}},
					{ title:'联系人', key:'contacts', dataIndex:'contacts', align:'center'},
					{ title:'电话', key:'tel', dataIndex:'tel',align:'center'},
					{ title:'地址', key:'address', dataIndex:'address', align:'center'},
					{ title:'状态', dataIndex:'ticketstationState', key:'ticketstationState', align:'center', scopedSlots:{customRender:'ticketstationState'}},
				],
				tableLoading: false,
				tableSelectedRows: {},
				//搜索+表格-end
				// 添加弹窗-start
				addVisible: false,
				addConfirmLoading: false,
				addForm: {
					facilitatorId: '',
					ticketstationName: '',
					contacts: '',
					tel: '',
					address: '',
					ticketstationState: 3,
					remarks: '',
				},
				addRules: {
					facilitatorId: [{ required: true, message: '请选择服务商', trigger: 'blur' }],
					ticketstationName: [{ required: true, message: '售票站点名称不能为空', trigger: 'blur' }],
					ticketstationState: [{ required: true, message: '请选择', trigger: 'blur' }],
				},
				// 添加弹窗-end
				// 修改弹窗-start
				editVisible: false,
				editConfirmLoading: false,
				editForm: {
					ticketstationId: '',
					facilitatorId: '',
					ticketstationName: '',
					contacts: '',
					tel: '',
					address: '',
					ticketstationState: 3,
					remarks: '',
				},
				// 修改弹窗-end
			};
		},
		methods: {
			//获取服务商列表
			async apiFacilitatorList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiFacilitatorList,{staffId:window.sessionStorage.getItem('staffId')});
				if (res.code == 200) {
					this.facilitatorList = res.data
					this.query.facilitatorId = res.data[0].facilitatorId
					this.mainNavigation[0] = res.data[0]
					this.apiTicketstationQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},

			//表格开始-搜索
			async apiTicketstationQueryList() {
				this.tableLoading = true
				for(let i=0;i<this.facilitatorList.length;i++){
					if(this.facilitatorList[i].facilitatorId == this.query.facilitatorId) {
						this.mainNavigation[0] = this.facilitatorList[i]
					}
				}
				const {
					data: res
				} = await this.$http.post(this.navigation.apiTicketstationQueryList, this.query);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					// this.$message.success(res.msg)
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiTicketstationQueryList()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiTicketstationQueryList()
			},
			async apiTicketstationAdd() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiTicketstationAdd, this.addForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.addRuleForm.resetFields();
					this.apiTicketstationQueryList()
					this.addConfirmLoading = false
					this.addVisible = false
				} else {
					this.$message.error(res.msg)
					this.addConfirmLoading = false
				}
			},
			addHandleOk() {
				this.$refs.addRuleForm.validate(valid => {
					if (valid) {
						this.apiTicketstationAdd()
					} else {
					  return false;
					  this.addConfirmLoading = true
					}
				});
				
			},
			//添加弹窗事件-结束
			//修改弹窗事件-开始
			edit(item){
				let items = JSON.parse(JSON.stringify(item))
				this.editForm = items
				this.editVisible = true
			},
			async apiTicketstationEdit() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiTicketstationEdit, this.editForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.editRuleForm.resetFields();
					this.apiTicketstationQueryList()
					this.editConfirmLoading = false
					this.editVisible = false
				} else {
					this.$message.error(res.msg)
					this.editConfirmLoading = false
				}
			},
			
			editHandleOk() {
				this.$refs.editRuleForm.validate(valid => {
					if (valid) {
						this.apiTicketstationEdit()
					} else {
					  return false;
					  this.editConfirmLoading = true
					}
				});
				
			},
			//修改弹窗事件-结束
			//删除
			tableDel() {
				let that = this
				if(this.tableSelectedRows.ticketstationId > 0) {
					this.$confirm({
						title: '确定要删除当前选中数据吗',
						content: this.tableSelectedRows.ticketstationName,
						okText: '确定',
						okType: 'danger',
						cancelText: '取消',
						onOk() {
							that.apiTicketstationDel()
						},
						onCancel() {
						},
					});
				}else{
					this.$message.warning('请选择要删除的数据');
				}
			},
			//删除
			async apiTicketstationDel() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiTicketstationDel, {ticketstationId: this.tableSelectedRows.ticketstationId});
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.apiTicketstationQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},

			tableEdit() {
				if(this.tableSelectedRows.ticketstationId > 0) {
					this.edit(this.tableSelectedRows)
				}else{
					this.$message.warning('请选择要修改的数据');
				}
			}
			
		},
		computed: {
			rowSelection() {
				let that = this
				return {
					type: 'radio',
					onChange: (selectedRowKeys, selectedRows) => {
						// console.log(selectedRows);
						that.tableSelectedRows = selectedRows[0];
					},
					// getCheckboxProps: record => ({
					// 	props: {
					// 		disabled: record.name === 'Disabled User', // Column configuration not to be checked
					// 		name: record.name,
					// 	},
					// }),
				};
			},
		},
		created() {
			this.apiFacilitatorList()
		}
	};
</script>

<style scoped>
	
</style>
